import React from "react";
import "./Socials.scss";

const InstagramLogo = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 78 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_41_7)">
        <path
          d="M53.4498 77.03H23.5898C10.5898 77.03 0.00977271 66.45 0.00977271 53.45V23.59C-0.000227292 10.58 10.5798 0 23.5798 0H53.4398C66.4398 0 77.0198 10.58 77.0198 23.58V53.44C77.0198 66.44 66.4398 77.02 53.4398 77.02L53.4498 77.03ZM23.5798 5.77C13.7598 5.77 5.75977 13.76 5.75977 23.59V53.45C5.75977 63.27 13.7498 71.27 23.5798 71.27H53.4398C63.2598 71.27 71.2598 63.28 71.2598 53.45V23.59C71.2598 13.77 63.2698 5.77 53.4398 5.77H23.5798Z"
          fill="white"
        />
        <path
          d="M38.5093 58C27.7693 58 19.0293 49.26 19.0293 38.52C19.0293 27.78 27.7693 19.04 38.5093 19.04C49.2493 19.04 57.9893 27.78 57.9893 38.52C57.9893 49.26 49.2493 58 38.5093 58ZM38.5093 24.94C31.0193 24.94 24.9293 31.03 24.9293 38.52C24.9293 46.01 31.0193 52.1 38.5093 52.1C45.9993 52.1 52.0893 46.01 52.0893 38.52C52.0893 31.03 45.9993 24.94 38.5093 24.94Z"
          fill="white"
        />
        <path
          d="M65.1908 16.9098C65.1908 19.7098 62.9208 21.9798 60.1208 21.9798C57.3208 21.9798 55.0508 19.7098 55.0508 16.9098C55.0508 14.1098 57.3208 11.8398 60.1208 11.8398C62.9208 11.8398 65.1908 14.1098 65.1908 16.9098Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_41_7">
          <rect width="77.03" height="77.03" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InstagramLogo;
